import * as angular from "angular";
import * as _ from "lodash";

angular
  .module('bringoz.admin.deliveries')
  .filter('servicePackagesCount', servicePackagesCount);

/* @ngInject */
function servicePackagesCount() {
  return function (packages) {
    return _.reduce(packages, (sum, p) => {
      return sum + _.get(p, 'count', 0);
    }, 0);
  };
}
